import React from 'react';

export const PlayerLazy = React.lazy(() => import('./Player'));
